// @generated by rtk-query-codegen -- DO NOT EDIT
import { baseApi as api } from "../client/baseApi";
import type { FailureCluster, ObservabilityCall, ObservabilityEvent, ObservabilityExternalLink, Timeline } from "../observability/controlPlane.generated";
import type { FailureSummaryResponse, FindCallsResponse, TimelineResponse } from "../observability/dto.generated";
export const addTagTypes = ["observability"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getApiWorkspacesByIdObservabilityCalls: build.query<
        GetApiWorkspacesByIdObservabilityCallsApiResponse,
        GetApiWorkspacesByIdObservabilityCallsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/observability/calls`,
          params: {
            from: queryArg["from"],
            to: queryArg.to,
            status: queryArg.status,
            operation_type: queryArg.operationType,
            error_fingerprint: queryArg.errorFingerprint,
            correlation_id: queryArg.correlationId,
            user_id: queryArg.userId,
            project_id: queryArg.projectId,
            source_id: queryArg.sourceId,
            cursor: queryArg.cursor,
            limit: queryArg.limit,
          },
        }),
        providesTags: ["observability"],
      }),
      getApiWorkspacesByIdObservabilityEtlRun: build.query<
        GetApiWorkspacesByIdObservabilityEtlRunApiResponse,
        GetApiWorkspacesByIdObservabilityEtlRunApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/observability/etl-run`,
          params: {
            etl_request_id: queryArg.etlRequestId,
            usecase_id: queryArg.usecaseId,
            from: queryArg["from"],
            to: queryArg.to,
            cursor: queryArg.cursor,
          },
        }),
        providesTags: ["observability"],
      }),
      getApiWorkspacesByIdObservabilityFailureSummary: build.query<
        GetApiWorkspacesByIdObservabilityFailureSummaryApiResponse,
        GetApiWorkspacesByIdObservabilityFailureSummaryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/observability/failure-summary`,
          params: {
            correlation_id: queryArg.correlationId,
          },
        }),
        providesTags: ["observability"],
      }),
      getApiWorkspacesByIdObservabilityLinkOwner: build.query<
        GetApiWorkspacesByIdObservabilityLinkOwnerApiResponse,
        GetApiWorkspacesByIdObservabilityLinkOwnerApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/observability/link-owner`,
          params: {
            provider: queryArg.provider,
            external_id: queryArg.externalId,
          },
        }),
        providesTags: ["observability"],
      }),
      getApiWorkspacesByIdObservabilityTimeline: build.query<
        GetApiWorkspacesByIdObservabilityTimelineApiResponse,
        GetApiWorkspacesByIdObservabilityTimelineApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/observability/timeline`,
          params: {
            correlation_id: queryArg.correlationId,
          },
        }),
        providesTags: ["observability"],
      }),
      getApiWorkspacesByIdObservabilityTopFailures: build.query<
        GetApiWorkspacesByIdObservabilityTopFailuresApiResponse,
        GetApiWorkspacesByIdObservabilityTopFailuresApiArg
      >({
        query: (queryArg) => ({
          url: `/api/workspaces/${encodeURIComponent(String(queryArg.id))}/observability/top-failures`,
          params: {
            from: queryArg["from"],
            to: queryArg.to,
            operation_type: queryArg.operationType,
            limit: queryArg.limit,
          },
        }),
        providesTags: ["observability"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as observabilityApi };
export type GetApiWorkspacesByIdObservabilityCallsApiResponse =
  /** status 200 OK */ { data: ObservabilityFindCallsResponse };
export type GetApiWorkspacesByIdObservabilityCallsApiArg = {
  /** Workspace ID */
  id: string;
  /** Start of time window (RFC3339) */
  from?: string;
  /** End of time window (RFC3339) */
  to?: string;
  /** Call status filter */
  status?: string;
  /** Operation type filter */
  operationType?: string;
  /** Error fingerprint filter */
  errorFingerprint?: string;
  /** Correlation ID filter */
  correlationId?: string;
  /** User ID filter */
  userId?: string;
  /** Project ID filter */
  projectId?: string;
  /** Source ID filter */
  sourceId?: string;
  /** Pagination cursor */
  cursor?: string;
  /** Maximum number of items to return */
  limit?: number;
};
export type GetApiWorkspacesByIdObservabilityEtlRunApiResponse =
  /** status 200 OK */ { data: ObservabilityFindCallsResponse };
export type GetApiWorkspacesByIdObservabilityEtlRunApiArg = {
  /** Workspace ID */
  id: string;
  /** auto-etl request ID */
  etlRequestId?: string;
  /** Usecase ID */
  usecaseId?: string;
  /** Start of time window (RFC3339) */
  from?: string;
  /** End of time window (RFC3339) */
  to?: string;
  /** Pagination cursor */
  cursor?: string;
};
export type GetApiWorkspacesByIdObservabilityFailureSummaryApiResponse =
  /** status 200 OK */ { data: ObservabilityFailureSummaryResponse };
export type GetApiWorkspacesByIdObservabilityFailureSummaryApiArg = {
  /** Workspace ID */
  id: string;
  /** Correlation ID of the operation to inspect */
  correlationId: string;
};
export type GetApiWorkspacesByIdObservabilityLinkOwnerApiResponse =
  /** status 200 OK */ { data: ControlPlaneObservabilityCall };
export type GetApiWorkspacesByIdObservabilityLinkOwnerApiArg = {
  /** Workspace ID */
  id: string;
  /** Evidence provider */
  provider: string;
  /** Vendor evidence id */
  externalId: string;
};
export type GetApiWorkspacesByIdObservabilityTimelineApiResponse =
  /** status 200 OK */ { data: ObservabilityTimelineResponse };
export type GetApiWorkspacesByIdObservabilityTimelineApiArg = {
  /** Workspace ID */
  id: string;
  /** Correlation ID of the operation to inspect */
  correlationId: string;
};
export type GetApiWorkspacesByIdObservabilityTopFailuresApiResponse =
  /** status 200 OK */ { data: ControlPlaneFailureCluster[] };
export type GetApiWorkspacesByIdObservabilityTopFailuresApiArg = {
  /** Workspace ID */
  id: string;
  /** Start of time window (RFC3339) */
  from?: string;
  /** End of time window (RFC3339) */
  to?: string;
  /** Operation type filter */
  operationType?: string;
  /** Maximum number of clusters to return */
  limit?: number;
};
export type ControlPlaneObservabilityCall = ObservabilityCall;
export type ObservabilityFindCallsResponse = FindCallsResponse;
export type ControlPlaneObservabilityExternalLink = ObservabilityExternalLink;
export type ObservabilityFailureSummaryResponse = FailureSummaryResponse;
export type ControlPlaneObservabilityEvent = ObservabilityEvent;
export type ControlPlaneTimeline = Timeline;
export type ObservabilityTimelineResponse = TimelineResponse;
export type ControlPlaneFailureCluster = FailureCluster;
export const {
  useGetApiWorkspacesByIdObservabilityCallsQuery,
  useLazyGetApiWorkspacesByIdObservabilityCallsQuery,
  useGetApiWorkspacesByIdObservabilityEtlRunQuery,
  useLazyGetApiWorkspacesByIdObservabilityEtlRunQuery,
  useGetApiWorkspacesByIdObservabilityFailureSummaryQuery,
  useLazyGetApiWorkspacesByIdObservabilityFailureSummaryQuery,
  useGetApiWorkspacesByIdObservabilityLinkOwnerQuery,
  useLazyGetApiWorkspacesByIdObservabilityLinkOwnerQuery,
  useGetApiWorkspacesByIdObservabilityTimelineQuery,
  useLazyGetApiWorkspacesByIdObservabilityTimelineQuery,
  useGetApiWorkspacesByIdObservabilityTopFailuresQuery,
  useLazyGetApiWorkspacesByIdObservabilityTopFailuresQuery,
} = injectedRtkApi;
